import { useState } from 'react';
import { isMobileDevice, isWeChatBrowser } from '../../util';
import './LoginPage.css';

function LoginPage() {

  //网页应用id
  const [WebAPPID] = useState("wxffa7f21059118c1d");
  //公众号id
  const [weChatAppID] = useState("wx61430451e4bbefe4")
  const [REDIRECT_URI] = useState(encodeURIComponent("https://oralshow.online/chat"));



  const requestWXLogin = () => {
    if (isMobileDevice()) {
      if (isWeChatBrowser()) {
        const url = "https://open.weixin.qq.com/connect/oauth2/authorize?"
          + "appid=" + weChatAppID
          + "&redirect_uri=" + REDIRECT_URI
          + "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect"
        window.location.href = url;
      } else {
        window.location.href = "https://danghe.live";
      }
    } else {
      // ... 微信登录逻辑 ...
      new window.WxLogin({
        self_redirect: false,
        id: "login",
        appid: WebAPPID,
        scope: "snsapi_login",
        redirect_uri: REDIRECT_URI,
        state: "",
        style: "white",
        href: ""
      });
    }
  };



  return (
    <div className="container">
      <div className="welcomePage">
        <h1>欢迎来到GenieShow：智能化的未来工作与学习平台</h1>
        <div className='wellcomeSentence'>
          <p>在GenieShow，我们通过集成最先进的智能技术，重新定义办公和学习的方式。我们的目标是为个人和团队提供一个全面的平台，使工作效率和学习效果得到前所未有的提升。无论您是寻求专业发展的个人，还是追求团队协作效率的企业，GenieShow都能为您提供量身定制的解决方案。</p>
        </div>
        <h2>核心功能与优势：</h2>
        <ul>
          <li><strong>辅助编程：</strong>利用最新的AI技术，提供代码自动补全、bug诊断和性能优化建议，助力开发者提高编码效率和项目质量。</li>
          <li><strong>教育辅导：</strong>全面辅导服务，涵盖家庭作业帮助、资料查询、教案制作，以及公务员、研究生、GRE、雅思、托福等考试准备。为家长、学生、教师及考生提供个性化学习方案和专业备考资源。</li>
          <li><strong>创意写作：</strong>无论是广告文案、营销策划还是内容创作，我们的智能写作工具和专业团队将激发您的创意，帮助您的项目和活动脱颖而出。</li>
          <li><strong>翻译服务：</strong>利用先进的AI翻译技术，我们提供精准的文档翻译和语言学习支持，帮助您跨越语言障碍，实现无缝的国际交流。</li>
          <li><strong>旅行规划：</strong>我们的智能推荐系统根据您的兴趣和需求，提供丰富的生活知识和定制旅行计划，让学习和生活更加丰富多彩。</li>
        </ul>
        <div className="slogan">
          <p><strong>选择GenieShow的理由：全面智能化支持、显著提升工作与学习效率、高度个性化的用户体验。</strong></p>
          <p><strong>立即加入GenieShow，开启您的智能工作与学习之旅，让我们一起构建更高效、更智能的未来。</strong></p>
        </div>

      </div>

      <div className="login" id="login">
        <button className="wechatLoginButton" onClick={requestWXLogin}>
          {isMobileDevice() && !isWeChatBrowser() ? '下载app' : '立即登录'}
        </button>
      </div>
      <div className="footer">
        <p>© 2020-2024 当禾科技. All rights reserved.</p>
        <a style={{color:"gray"}} href="https://beian.miit.gov.cn">蜀ICP备20020842号-1</a>
      </div>
    </div>
  );
}

export default LoginPage;
